<template>
  <div class="case-list-item border" @click="toDetails">
    <div class="flex m-b-20">
      <div class="dian m-t-15 primary-bg m-r-15"></div>
      <div class="f-1 font-lg lh-48">{{name}}</div>
    </div>
    <div class="f-x-end w-100b m-b-20">
      <div class="product gray-bg p-20 radius-8 ellipsis">{{product}}</div>
    </div>
    <div class="w-100b darkgray-font font p-l-25 p-r-20 m-b-20 f-between">
      <div>编号：{{num}}</div>
      <div>{{time}}</div>
    </div>
    <div class="darkgray-font font p-l-25 w-100b m-b-20 radius-8 ellipsis">{{lawTypeDictEs}}</div>
    <div class="f-y-center p-l-25">
      <img class="avatarImage m-r-15" :src="lawyerAvatar" />
      <div class="primary-font font-lg p-r-20">{{lawyerName}}</div>
      <div class="darkgray-font font-sm border-l p-l-20">{{lawOffice}}</div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onBeforeMount } from 'vue'
import router from '@/router'
import { getUrlQuery, isUrl } from '@/utils/url.js'
import { fileApi } from '@/apis'
// /news/details/:id
export default {
  props: {
    lawyerName: String,
    lawyerAvatar: String,
    lawOffice: String,
    name: String,
    product: String,
    num: String,
    time: String,
    lawTypeDictEs: String,
  },
  setup(props, { emit }) {
    const toDetails = () => {
      router.push('/case/details/2')
    }
    return { toDetails }
  },
}
</script>

<style lang="scss">
.case-list-item {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  padding: 20px 20px 20px 20px;
  background-color: #fff;
  .dian {
    width: 16px;
    height: 16px;
    border-radius: 50%;
  }
  .product {
    width: 92vw;
  }
  .avatarImage {
    width: 92px;
    height: 92px;
    border-radius: 50%;
  }
}
</style>